// removed by extract-text-webpack-plugin
module.exports = {"Coconut":"#F4F7FA","ScreenXSMax":"(max-width: 767px)","HeightSMMax":"(max-height: 639px)","pageContainer":"G6c15e9","headerContainer":"G862702"};